export const FtxStrategyListItem = (props: any) => {
  const token = props['strategy']['product'] ? props['strategy']['product'].split('-')[0].toUpperCase() : null
  const tokenImgPath = `https://ai.supercoin.network/img/coin/${token}.png`
  return (
    <>
      <div className="d-flex justify-content-between align-items-end pt-2 text-dark" style={{ "fontSize": "12px" }}>
        <div className="align-self-center" style={{ "lineHeight": "10px" }}>
          <input type="radio" name="type" id={props['strategy']['strategy']} onChange={() => props.onSelect(props['strategy']['strategy'])} />
        </div>
        <label htmlFor={props['strategy']['strategy']} className="mb-0">
          <div className="ai-icon rbg">{token ? <img style={{'width': '100%', 'marginTop': '-4px'}} src={tokenImgPath} alt="" /> : "無"}</div>
        </label>
        <div className="d-flex flex-column flex-grow-1">
          <span className="text-dark font-weight-bold" style={{ "fontSize": "14px" }}>{props['strategy']['title']}
          </span>
          <div>({props['strategy']['strategy']})</div>
        </div>
        <div className="d-flex flex-column flex-grow-1 align-self-center text-right" style={{'textAlign': 'right'}}>
          <span className="text-danger">{props['strategy']['product']}</span>
          <span className="text-danger"><a href={`https://file.sup.me.uk/sai/${props['strategy']['strategy']}.pdf`}>績效下載</a></span>
        </div>
      </div>
      <div className="list-hr" style={{ "width": "100%" }}></div>
    </>
  )
}